import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tooltip } from 'antd';
import styles from './styles.less';
import { LocalizationContext } from '../../../hoc/Localization';

const Skill = ({ skills }) => {
  const { locale } = useContext(LocalizationContext);
  return (
    <Row>
      {skills.map(skill => (
        <Col key={skill.id} span={12} xs={12}>
          <div className={styles.skill}>
            <div className={styles.image}>
              <img alt="skill" src={skill.image && skill.image.url} className={styles.image} />
            </div>
            <div className={styles.text}>
              <h3>{skill[`title_${locale}`]}</h3>
              <Tooltip placement="topLeft" title={skill.description}>
                <p>{skill[`description_${locale}`]}</p>
              </Tooltip>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

Skill.propTypes = {
  skills: PropTypes.array,
};

Skill.defaultProps = {
  skills: [],
};

export default Skill;
